module.exports = ['$rootScope', '$window', '$location', '$cookies', '$translate', function($rootScope, $window, $location, $cookies, $translate) {
  // Defensively wipe any lingering `userInfo` cookie. The server stopped
  // writing this cookie on 2026-05-14 (the JSON payload + SimpleCookie's
  // \054 comma-escaping was corrupting localStorage on every reload — see
  // accounts/api.py for the full story). Existing user browsers may still
  // carry a stale session cookie until restart; clear it across every
  // possible Domain= variant + host-only so it can't be re-ingested below.
  ['.bblapp.io', '.brandedbridgeline.com'].forEach(function(d) {
    $cookies.remove('userInfo', {domain: d});
  });
  $cookies.remove('userInfo');  // host-only

  // localStorage is now the sole source of truth for userInfo. If parse
  // fails, the auth flow re-authenticates and saveUserInfo() writes a
  // fresh value — no more ingesting a (possibly broken) cookie value here.
  var userInfo = $window.localStorage.userInfo;
  try { JSON.parse(userInfo); }
  catch(e) {
    // unparseable → drop it so auth-service doesn't re-throw on every
    // page load. Worst case: user logs in once.
    $window.localStorage.removeItem('userInfo');
  }

  //
  $rootScope.$on('$routeChangeStart',function(angularEvent, next) {
    $rootScope.onLoginLayout = next.$$route !== undefined && next.$$route.loginLayout !== undefined && next.$$route.loginLayout;
    $rootScope.onInvitedLayout = next.$$route !== undefined && next.$$route.invitedLayout !== undefined && next.$$route.invitedLayout;
    $rootScope.onParticularBrand = next.$$route !== undefined && next.$$route.particularBrand !== undefined && next.$$route.particularBrand;
  });

  $rootScope.$on('$routeChangeError', function(event, current, previous, eventObj) {
    if(eventObj !== undefined && eventObj.authenticated === false || eventObj.status === 401) {
      // if($location.path().indexOf('logout') > -1){
      //   return $location.path("/");
      // }

      $location.path("/login");
    }
    else if(eventObj !== undefined && eventObj.free_user === false) {
      $location.path("/plans-billing-update");
    }
    else if(eventObj !== undefined && eventObj.paid_user === false) {
      $location.path("/plans-billing");
    }
  });

  // config user locale
  var lang = $location.search().ln;
  if (lang) {
    $translate.use(lang);
    $location.search('ln', null);
  }

  console.info('Detected language:', $translate.use());
  window.chl = $translate.use.bind($translate);
}];



/*****************
 ** WEBPACK FOOTER
 ** ./app/app-run.js
 ** module id = 125
 ** module chunks = 0
 **/